/**
 * Same shelf-life formula as Picklist PDF (generatePicklistPdf.js)
 * and Delivery Order PDF (generateDeliveryOrderPdf.js).
 */
export function computeShelfLifePercent(manufacturingDate, expiryDate) {
  let shelfLifePct = "-";
  const mfgD = manufacturingDate ? new Date(manufacturingDate) : null;
  const expD = expiryDate ? new Date(expiryDate) : null;
  if (mfgD && expD && Number.isFinite(mfgD.getTime()) && Number.isFinite(expD.getTime())) {
    const totalLife = expD.getTime() - mfgD.getTime();
    const remaining = expD.getTime() - Date.now();
    if (totalLife > 0) {
      shelfLifePct = `${Math.max(0, Math.min(100, Math.round((remaining / totalLife) * 100)))}%`;
    }
  }
  return shelfLifePct;
}
